import { render } from "./navbar.vue?vue&type=template&id=15794775"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=15794775&lang=css"

import exportComponent from "/var/www/dt_project_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__